module.exports = __webpack_public_path__ + "img/truck-red.b07e9e38.svg";